import { Link } from 'react-router-dom';
import './LinkListing.css';

type LinkListingProps = {
	showBorder?: boolean;
	isDense?: boolean;
	links: {
		url: string;
		text: string;
		key: string;
	}[];
};

export const LinkListing = (props: LinkListingProps): JSX.Element => {
	return (
		<ul
			className={`link-listing ${props.showBorder && 'link-listing-border'} ${
				props.isDense && 'link-listing--is-small'
			}`}
		>
			{props.links.map((link) => (
				<li key={link.key}>
					<Link to={link.url}>{link.text}</Link>
				</li>
			))}
		</ul>
	);
};
